import type { Card } from '../../types';

/** Entry-level recursive (gives the type a common, ADR-0015 §8). One fresh die;
 * a high face hits the enemy, a low face fizzles. */
export const SPARK: Card = {
  id: 'spark',
  name: 'Spark',
  type: 'recursive',
  rarity: 'common',
  size: { w: 1, h: 1 },
  cost: [{ kind: 'min', value: 1 }],
  effects: [
    {
      kind: 'rollFresh',
      count: 1,
      perFace: [
        {
          facePredicate: { kind: 'min', value: 4 },
          effects: [{ kind: 'damage', amount: 4, target: 'opponent' }],
        },
      ],
    },
  ],
};
